import { render } from "./CategoryPicker.vue?vue&type=template&id=4c29ebb1&scoped=true"
import script from "./CategoryPicker.vue?vue&type=script&lang=js"
export * from "./CategoryPicker.vue?vue&type=script&lang=js"

import "./CategoryPicker.vue?vue&type=style&index=0&id=4c29ebb1&scoped=true&lang=css"

import exportComponent from "/Users/johan/dev/litteraturkartan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c29ebb1"]])

export default __exports__